import { h } from "preact";
import store from "../store";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { useEffect } from "preact/hooks";
import { Provider, useDispatch, useSelector } from "react-redux";
import MinistryReport from "../routes/MinistryReport";
import style from "./style.scss";
import { initApp, refreshUser } from "../action";
import StudentReport from "../routes/StudentReport";
import TeacherReport from "../routes/TeacherReport";
import PrincipalReport from "../routes/PrincipalReport";
import { Route } from "preact-router";
import Login from "../routes/Login";
import Reset from "../routes/Reset";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import PISASchoolsDashboard from "../routes/PISASchoolsDashboard";

const AppWrapper = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userSession = useSelector((state) => state.userSession);
  useEffect(() => {
    dispatch(initApp(history));
  }, []);
  useEffect(() => {
    if (userSession && userSession.tokenRefreshed)
      dispatch(refreshUser(history));
  }, [userSession, history]);
};

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <div id="app" className={style["report--body"]}>
          <AppWrapper />
          <Switch>
            <Route path="/pisa-schools" exact component={PISASchoolsDashboard} />
            <Route path="/ministry-report" exact component={MinistryReport} />
            <Route path="/student-report" exact component={StudentReport} />
            <Route path="/teacher-report" exact component={TeacherReport} />
            <Route path="/principal-report" exact component={PrincipalReport} />
            <Route path="/login" exact component={Login} />
            <Route path="/reset" component={Reset} />
          </Switch>
        </div>
      </Router>
    </Provider>
  );
};

export default App;
